var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.52 4l-.59 1.005.59.995c3.178 0 5.76 2.69 5.76 6 0 1.01-.24 1.97-.672 2.8l1.402 1.46A8.174 8.174 0 0019.2 12c0-4.42-3.437-8-7.68-8zM5.76 12c0 3.31 2.582 6 5.76 6l.568 1.014-.568.986c-4.243 0-7.68-3.58-7.68-8 0-1.57.442-3.03 1.19-4.26L6.432 9.2A6.066 6.066 0 005.76 12z",
    fill: "#1B1D1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.777 8.558l-1.79.894-2.223-4.45L10.988.556l1.788.895-1.775 3.55 1.776 3.556zM10.223 15.401l1.789-.894 2.223 4.451-2.223 4.444-1.789-.895 1.775-3.55-1.775-3.556z",
    fill: "#1B1D1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.422a511e.svg";
export { ForwardRef as ReactComponent };